import { createSlice } from "@reduxjs/toolkit";
import { getCCFData } from "./thunk";

const getCCFDataSlice = createSlice({
    name: "getCCFData",
    initialState: {
        isLoading: false,
        isError: false,
        data: [],
    },
    extraReducers: (builder) => {
        builder.addCase(getCCFData.pending, (state) => {
            state.isLoading = true;
            state.isError = false;
        });
        builder.addCase(getCCFData.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(getCCFData.rejected, (state) => {
            state.isError = true;
            state.isLoading = false;
        });

    }
});

export default getCCFDataSlice.reducer;